import { render, staticRenderFns } from "./SegurStats.vue?vue&type=template&id=714636d4&scoped=true"
import script from "./SegurStats.vue?vue&type=script&lang=js"
export * from "./SegurStats.vue?vue&type=script&lang=js"
import style0 from "./SegurStats.vue?vue&type=style&index=0&id=714636d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714636d4",
  null
  
)

export default component.exports